module.exports = __webpack_public_path__ + "static/media/rooftop_low_impact_dance_workout.20da449f.webp";